export enum ScheduleType {
  CreatedDate = 'date',
  PulloutSchedule = 'pulloutSchedule',
  DeliverySchedule = 'deliverySchedule',
  MTYPU = 'pickupSchedule',
  ReturnSchedule = 'returnSchedule'
}
